import RefreshIcon from "@mui/icons-material/Refresh";
import {
	AppBar,
	Box,
	CssBaseline,
	IconButton,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import logoV2 from "../../assets/logos/logo-powered-2.png";
import BackdropLoader from "../../components/BackdropLoader";
import { LangSwitcher } from "../../components/lang-switcher";
import { PublicListingTable } from "../../components/tables/PublicListingTable";
import { useGetCarrierRelatedCargosQuery } from "../../features/offers/offersApiSlice";

const POLLING_INTERVAL = 300_000;

export const PublicListing = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");

	const {
		data: cargos,
		error,
		isLoading,
		isFetching,
		refetch,
	} = useGetCarrierRelatedCargosQuery(token, {
		pollingInterval: POLLING_INTERVAL,
	});

	return (
        <>
            <Box sx={{ display: "flex" }}>
				<CssBaseline />
				<AppBar
					position="fixed"
					sx={{
						width: `100%`,
						background: "#284B7A",
						boxShadow: "none",
					}}
				>
					<Toolbar
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
						}}
						variant="dense"
					>
						<Box>
							<LangSwitcher />
						</Box>
						{/* todo: translate URL */}
						<a
							href="https://cargoseller.pl/"
							target="_blank"
							rel="noopener noreferrer"
							style={{
								display: "inline-flex",
								alignItems: "center",
								maxWidth: "150px",
							}}
						>
							<img
								src={logoV2}
								alt="Powered by CARGOseller"
								style={{ height: "100%", width: "100%", objectFit: "contain" }}
							/>
						</a>
					</Toolbar>
				</AppBar>
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						bgcolor: "background.default",
						maxWidth: "100svw",
					}}
				>
					<Toolbar variant="dense" />
					<Box
                        sx={{
                            maxWidth: "xl",
                            margin: "0 auto",
                            px: 4,
                            py: 3
                        }}>
						<Box sx={{ textAlign: "left" }}>
							<Typography component="h1" variant="h3" sx={{ mb: 0 }}>
								{t("cargos_list")}
							</Typography>
							<Typography
								component="p"
								sx={{ color: "#ada5ad", fontSize: "13pt" }}
							>
								{t("you_can_check_public_cargos")}
							</Typography>
						</Box>
						<Box sx={{ position: "relative" }}>
							<Tooltip
								title={
									<Typography
										variant="p"
										sx={{ fontSize: "9pt" }}
										component="span"
									>
										{t("refresh_cargos")}
									</Typography>
								}
								placement="bottom"
							>
								<IconButton
									disableRipple
									size="small"
									sx={{
										background: "#63c29a",
										position: "absolute",
										right: "0",
										top: "26px",
										zIndex: "100",
									}}
									aria-label="refresh"
									onClick={refetch}
								>
									<RefreshIcon sx={{ color: "#fff", fontSize: "14px" }} />
								</IconButton>
							</Tooltip>

							<PublicListingTable
								isLoading={isLoading}
								data={cargos?.data || []}
							/>
						</Box>
					</Box>
				</Box>
			</Box>
            <BackdropLoader isOpen={isFetching && !isLoading} />
        </>
    );
};
